import upperFirst from './upper-first';

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function prefixPropName(prefix, value) {
  return prefix + upperFirst(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/prefix-prop-name.js
// module id = 7+8w
// module chunks = 14